import { useVisitCount } from '@/hooks/useVisitCount';
import * as React from 'react';
import { Container } from '../container/Container';
import clsx from 'clsx';
import { Button } from '../button/Button';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import heroVideo1 from '@/images/hero/hero-video-1.mp4';
import heroVideo2 from '@/images/hero/hero-video-2.mp4';
import heroVideo3 from '@/images/hero/hero-video-3.mp4';
import heroVideo4 from '@/images/hero/hero-video-4.mp4';
import heroVideo5 from '@/images/hero/hero-video-5.mp4';
import { routes } from '@/routes/routes';
import { CelebrateIcon } from '../icons/CelebrateIcon';
import * as styles from './Hero.module.scss';

const videos = [heroVideo1, heroVideo2, heroVideo3, heroVideo4, heroVideo5];

export const Hero = ({
  withLaunchingInfo,
  texts,
  className,
}: {
  withLaunchingInfo?: boolean;
  texts: string[];
  className?: string;
}) => {
  const visitCount = useVisitCount();
  const assetIndex = visitCount % videos.length;
  const textIndex = visitCount % texts.length;
  const staticImagesData = useStaticQuery(STATIC_IMAGES_QUERY);

  const images = staticImagesData.allFile.nodes
    .filter((file: any) => file.extension !== 'mp4' && file.childImageSharp)
    .map((file: any) => ({
      image: getImage(file.childImageSharp.gatsbyImageData),
      alt: `Image ${file.publicURL}`,
    }));

  return (
    <div className={clsx(styles.hero, className)}>
      <GatsbyImage image={images[assetIndex].image} className={styles.hero__img} alt="background first video frame" />
      <video autoPlay muted loop playsInline className={styles.hero__video}>
        <source src={videos[assetIndex]} type="video/mp4" />
      </video>
      <div className={styles.hero__parts}>
        <Container>
          {withLaunchingInfo ? (
            <div className={styles.hero__topBanner}>
              <CelebrateIcon className={styles.hero__bannerIcon} />
              <p className={styles.hero__bannerText}>Our new website will be launching soon!</p>
            </div>
          ) : null}
          <div
            className={clsx(
              styles.hero__heroPart,
              styles.hero__text,
              withLaunchingInfo && styles.hero__text___withLaunchingInfo,
            )}
          >
            <p>{texts[textIndex]}</p>
          </div>
          {!withLaunchingInfo ? (
            <div className={clsx(styles.hero__heroPart, styles.hero__ctaButtonWrapper)}>
              <Button asLink to={routes.work}>
                See our projects
              </Button>
            </div>
          ) : null}
          <div className={styles.hero__footer}>
            <p>Cochran, Inc.</p>
            <p>Building brilliance</p>
            <p className={styles.hero__estLabel}>Est. 1954</p>
          </div>
        </Container>
      </div>
    </div>
  );
};

const STATIC_IMAGES_QUERY = graphql`
  query allFile {
    allFile(filter: { relativeDirectory: { eq: "hero/images" } }) {
      nodes {
        extension
        publicURL
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, width: 1920)
        }
      }
    }
  }
`;
